import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import ngMaterial from 'angular-material';
import * as Common from './common';
import * as Components from './components';
import * as Services from './services';
import * as Filters from './filters';
import AppRoutes from './app.router';
import { AppConfig, EventEmitter } from './app.config';
import AppBootstrap from './app.bootstrap';
import AppComponent from './app.settings';

import './app-styles';

const mdDataTable = require('angular-material-data-table');
const uiTree = require('angular-ui-tree');
const angularMoment = require('angular-moment');
const ngMap = require('ngmap');
const ngMessages = require('angular-messages');
const ngSanitize = require('angular-sanitize');

/**
 * Common module name
 */
const dtCommon = angular
    .module('dt.common', [ngMap])
    .config(Common.Tree.Config)
    .component(Common.ContentComponent.selector, Common.ContentComponent.options)
    .component(Common.ContentHeaderComponent.selector, Common.ContentHeaderComponent.options)
    .component(Common.Tree.FolderSelectorComponent.selector, Common.Tree.FolderSelectorComponent.options)
    .component(Common.EmptyState.selector, Common.EmptyState.options)
    .component(Common.HeaderComponent.selector, Common.HeaderComponent.options)
    .component(Common.HelpIconComponent.selector, Common.HelpIconComponent.options)
    .component(Common.HelpMenuComponent.Component.selector, Common.HelpMenuComponent.Component.options)
    .component(Common.HelpMenuComponent.ApplicationHelp.selector, Common.HelpMenuComponent.ApplicationHelp.options)
    .component(Common.HelpMenuComponent.FeedbackForm.selector, Common.HelpMenuComponent.FeedbackForm.options)
    .directive(Common.ScreenshotDirective.selector, Common.ScreenshotDirective.options)
    .directive(Common.DragDrop.selector, Common.DragDrop.options)
    .component(Common.IconComponent.selector, Common.IconComponent.options)
    .directive(Common.IconDirective.selector, Common.IconDirective.options)
    .directive(Common.ShyDirective.selector, Common.ShyDirective.options)
    .directive(Common.StickyDirective.selector, Common.StickyDirective.options)
    .directive(Common.GetFocusDirective.selector, Common.GetFocusDirective.options)
    .directive(Common.GetWidthDirective.selector, Common.GetWidthDirective.options)
    .directive(Common.BackropDirective.selector, Common.BackropDirective.options)
    .directive(Common.BlockLoaderDirective.selector, Common.BlockLoaderDirective.options)
    .directive(Common.ChartDirective.selector, Common.ChartDirective.options)
    .directive(Common.EditNavBarDirective.selector, Common.EditNavBarDirective.options)
    .directive(Common.OnEnterDirective.selector, Common.OnEnterDirective.options)
    .component(Common.MapComponent.selector, Common.MapComponent.options)
    .component(Common.LayoutComponent.selector, Common.LayoutComponent.options)
    .component(Common.LoaderComponent.selector, Common.LoaderComponent.options)
    .service(Common.LoaderService.name, Common.LoaderService.definition)
    .component(Common.Navigation.LeftNavigationComponent.selector, Common.Navigation.LeftNavigationComponent.options)
    .component(Common.Navigation.TabsComponent.selector, Common.Navigation.TabsComponent.options)
    .component(Common.AccessManagementComponent.selector, Common.AccessManagementComponent.options)
    .component(Common.RulesListComponent.selector, Common.RulesListComponent.options)
    .component(Common.RuleComponent.selector, Common.RuleComponent.options)
    .component(Common.BatteryStatusComponent.selector, Common.BatteryStatusComponent.options)
    .component(Common.FolderPathComponent.selector, Common.FolderPathComponent.options)
    .directive(Common.FolderPathEditDirective.selector, Common.FolderPathEditDirective.options)
    .component(Common.RadioStatusComponent.selector, Common.RadioStatusComponent.options)
    .component(Common.ThingStarComponent.selector, Common.ThingStarComponent.options)
    .component(Common.SearchBox.selector, Common.SearchBox.options)
    .component(Common.UserPopover.selector, Common.UserPopover.options)
    .directive(Common.SaveView.Directive.selector, Common.SaveView.Directive.options)
    .directive(Common.mdCustomColumnDirective.selector, Common.mdCustomColumnDirective.options)
    .component(Common.EntitiesListComponent.selector, Common.EntitiesListComponent.options)
    .component(Common.SearchAutocompleteComponent.selector, Common.SearchAutocompleteComponent.options)
    .component(Common.EntitiesAutocompleteComponent.selector, Common.EntitiesAutocompleteComponent.options)
    .component(Common.LabelsAutocompleteComponent.selector, Common.LabelsAutocompleteComponent.options)
    .component(Common.SplashScreen.selector, Common.SplashScreen.options)
    .name
;

const dashboard = Components.Dashboard;
const sensorsAndConnectors = Components.SensorsAndConnectors;
const foldersAndLabels = Components.FoldersAndLabels;
const usersAndAccess = Components.UsersAndAccess;
const developerSettings = Components.DeveloperSettings;
const alertsActions = Components.AlertsActions;
const accountSettings = Components.AccountSettings;
const companySettings = Components.CompanySettings;
const notifications = Components.Notifications;

const sacsComponents = sensorsAndConnectors.Components;
const details = sacsComponents.ThingDetails;
const search = sacsComponents.Search;

/**
 * Components module name
 */
const dtComponents = angular
    .module('dt.components', [mdDataTable])
    .config(dashboard.Config)
    .component(dashboard.Component.selector, dashboard.Component.options)
    .config(sensorsAndConnectors.Routes)
    .config(sensorsAndConnectors.Graphs.Routes)
    .component(sensorsAndConnectors.Component.selector, sensorsAndConnectors.Component.options)
    .component(sensorsAndConnectors.Tabs.selector, sensorsAndConnectors.Tabs.options)
    .component(sensorsAndConnectors.ListContainer.selector, sensorsAndConnectors.ListContainer.options)
    .component(sensorsAndConnectors.Graphs.Component.selector, sensorsAndConnectors.Graphs.Component.options)
    .component(
        sensorsAndConnectors.Components.ThingChartComponent.selector,
        sensorsAndConnectors.Components.ThingChartComponent.options
    )

    // THING DETAILS: START
    .component(details.Component.selector, details.Component.options)
    .component(details.AdvancedInformationComponent.selector, details.AdvancedInformationComponent.options)
    .component(details.AlertBoxComponent.selector, details.AlertBoxComponent.options)
    .component(details.DetailsChartComponent.selector, details.DetailsChartComponent.options)
    .component(details.GeneralInformationComponent.selector, details.GeneralInformationComponent.options)
    .component(details.ThingLocation.selector, details.ThingLocation.options)
    .component(details.ThingName.selector, details.ThingName.options)
    .component(details.ThingDetailsLabels.selector, details.ThingDetailsLabels.options)
    .component(details.ThingDetailsFolder.selector, details.ThingDetailsFolder.options)
    .component(details.ThingDescription.selector, details.ThingDescription.options)
    .component(details.NotesComponent.selector, details.NotesComponent.options)
    .component(details.PermissionsComponent.selector, details.PermissionsComponent.options)
    .component(details.RecentEventsComponent.selector, details.RecentEventsComponent.options)
    // THING DETAILS: END

    .component(sacsComponents.ThingsToolboxComponent.selector, sacsComponents.ThingsToolboxComponent.options)
    .component(sacsComponents.ThingsListComponent.selector, sacsComponents.ThingsListComponent.options)

    // SIMPLE SEARCH: START
    .component(search.SimpleSearchComponent.selector, search.SimpleSearchComponent.options)
    // SIMPLE SEARCH: END

    // ADVANCED SEARCH: START
    .component(search.AdvancedSearch.Component.selector, search.AdvancedSearch.Component.options)
    .component(search.AdvancedSearch.ThingNameComponent.selector, search.AdvancedSearch.ThingNameComponent.options)
    .component(search.AdvancedSearch.ThingOwnerComponent.selector, search.AdvancedSearch.ThingOwnerComponent.options)
    .component(
        search.AdvancedSearch.ThingStatusComponent.selector,
        search.AdvancedSearch.ThingStatusComponent.options
    )
    .component(
        search.AdvancedSearch.ThingStarComponent.selector,
        search.AdvancedSearch.ThingStarComponent.options
    )
    .component(
        search.AdvancedSearch.ThingPictureComponent.selector,
        search.AdvancedSearch.ThingPictureComponent.options
    )
    .component(
        search.AdvancedSearch.ThingTypeComponent.selector,
        search.AdvancedSearch.ThingTypeComponent.options
    )
    .component(
        search.AdvancedSearch.ThingBatteryComponent.selector,
        search.AdvancedSearch.ThingBatteryComponent.options
    )
    .component(
        search.AdvancedSearch.ThingSignalComponent.selector,
        search.AdvancedSearch.ThingSignalComponent.options
    )
    .component(
        search.AdvancedSearch.ThingRegisteredComponent.selector,
        search.AdvancedSearch.ThingRegisteredComponent.options
    )
    .component(
        search.AdvancedSearch.ThingUpdatedComponent.selector,
        search.AdvancedSearch.ThingUpdatedComponent.options
    )
    .component(
        search.AdvancedSearch.ThingLocationComponent.selector,
        search.AdvancedSearch.ThingLocationComponent.options
    )
    .component(
        search.AdvancedSearch.ThingLabelsComponent.selector,
        search.AdvancedSearch.ThingLabelsComponent.options
    )
    .component(
        search.AdvancedSearch.ThingNotesComponent.selector,
        search.AdvancedSearch.ThingNotesComponent.options
    )
    .component(
        search.AdvancedSearch.ThingFoldersComponent.selector,
        search.AdvancedSearch.ThingFoldersComponent.options
    )
    // ADVANCED SEARCH: END


    // FOLDERS AND LABELS: START
    .config(foldersAndLabels.Config)
    .config(foldersAndLabels.Folders.Config)
    .config(foldersAndLabels.Labels.Config)
    .component(foldersAndLabels.Component.selector, foldersAndLabels.Component.options)
    .component(foldersAndLabels.Folders.Component.selector, foldersAndLabels.Folders.Component.options)
    .component(foldersAndLabels.Folders.FolderDetails.selector, foldersAndLabels.Folders.FolderDetails.options)
    .component(
        foldersAndLabels.Folders.FolderTree.Component.selector,
        foldersAndLabels.Folders.FolderTree.Component.options
    )
    .component(
        foldersAndLabels.Folders.FolderTree.AddFolderComponent.selector,
        foldersAndLabels.Folders.FolderTree.AddFolderComponent.options
    )
    .component(foldersAndLabels.Labels.Component.selector, foldersAndLabels.Labels.Component.options)
    .component(foldersAndLabels.Labels.LabelDetails.selector, foldersAndLabels.Labels.LabelDetails.options)
    // FOLDERS AND LABELS: END


    // USERS AND ACCESS: START
    .config(usersAndAccess.Config)
    .config(usersAndAccess.Users.Config)
    .config(usersAndAccess.Roles.Config)
    .config(usersAndAccess.Customers.Config)
    .component(usersAndAccess.Component.selector, usersAndAccess.Component.options)
    .component(usersAndAccess.Users.Component.selector, usersAndAccess.Users.Component.options)
    .component(usersAndAccess.Users.UACAddUser.selector, usersAndAccess.Users.UACAddUser.options)
    .component(usersAndAccess.Roles.Component.selector, usersAndAccess.Roles.Component.options)
    .component(usersAndAccess.Roles.UACRoleUsers.selector, usersAndAccess.Roles.UACRoleUsers.options)
    .component(usersAndAccess.Customers.Component.selector, usersAndAccess.Customers.Component.options)
    // USERS AND ACCESS: END

    // Developer Settings: START
    .config(developerSettings.Config)
    // .config(developerSettings.apiAccess.Config)
    .component(developerSettings.Component.selector, developerSettings.Component.options)
    .component(developerSettings.apiAccess.Component.selector, developerSettings.apiAccess.Component.options)
    // Developer Settings: END

    // Alerts & Actions: START
    .config(alertsActions.Config)
    .component(alertsActions.Component.selector, alertsActions.Component.options)
    .component(alertsActions.AlertsActionsNav.selector, alertsActions.AlertsActionsNav.options)
    .component(
        alertsActions.AlertsActionsContent.Component.selector,
        alertsActions.AlertsActionsContent.Component.options
    )
    .component(
        alertsActions.AlertsActionsContent.Actions.Component.selector,
        alertsActions.AlertsActionsContent.Actions.Component.options
    )
    .component(
        alertsActions.AlertsActionsContent.Actions.CreateNotifications.selector,
        alertsActions.AlertsActionsContent.Actions.CreateNotifications.options
    )
    .component(
        alertsActions.AlertsActionsContent.Actions.SendMail.selector,
        alertsActions.AlertsActionsContent.Actions.SendMail.options
    )
    .component(
        alertsActions.AlertsActionsContent.Actions.TriggerWebhook.selector,
        alertsActions.AlertsActionsContent.Actions.TriggerWebhook.options
    )
    .component(
        alertsActions.AlertsActionsContent.TimePeriod.Component.selector,
        alertsActions.AlertsActionsContent.TimePeriod.Component.options
    )
    .component(
        alertsActions.AlertsActionsContent.TimePeriod.SpecificTime.selector,
        alertsActions.AlertsActionsContent.TimePeriod.SpecificTime.options
    )
    // Alerts & Actions: END

    // Accounts Settings: START
    .config(accountSettings.Config)
    .component(accountSettings.Component.selector, accountSettings.Component.options)
    // Accounts Settings: END

    // Company Settings: START
    .config(companySettings.Config)
    .component(companySettings.Component.selector, companySettings.Component.options)
    // Company Settings: END

    // Company Notifications: START
    .config(notifications.Config)
    .component(notifications.Component.selector, notifications.Component.options)
    // Company Notifications: END
    .name
;

angular
    .module('app', [ngMessages, uiRouter, ngMaterial, ngSanitize, uiTree, dtCommon, dtComponents, angularMoment])
    .component(AppComponent.selector, AppComponent.options)
    .config(AppRoutes)
    .config(AppConfig)
    .config(Services.Auth.InterceptorConfig)
    .service(Services.Interceptors.HttpInterceptor.name, Services.Interceptors.HttpInterceptor.definition)
    .value(EventEmitter.name, EventEmitter.definition)
    .service(Services.Config.RemoteConfigService.name, Services.Config.RemoteConfigService.definition)
    .service(Services.Things.Service.name, Services.Things.Service.definition)
    .service(Services.Notifications.Service.name, Services.Notifications.Service.definition)
    .service(Services.Errors.Service.name, Services.Errors.Service.definition)
    .service(Services.Help.Service.name, Services.Help.Service.definition)
    .service(Services.Geo.Service.name, Services.Geo.Service.definition)
    .service(Services.CharsService.name, Services.CharsService.definition)
    .service(Services.DialogService.name, Services.DialogService.definition)
    .service(Services.FolderService.name, Services.FolderService.definition)
    .service(Services.HealthCheckerService.name, Services.HealthCheckerService.definition)
    .service(Services.Auth.AuthService.name, Services.Auth.AuthService.definition)
    .service(Services.ToastService.name, Services.ToastService.definition)
    .service(Services.TranslationService.name, Services.TranslationService.definition)
    .service(Services.NavigationService.name, Services.NavigationService.definition)
    .service(Services.Api.MenuApiService.name, Services.Api.MenuApiService.definition)
    .service(Services.Api.DeveloperApiService.name, Services.Api.DeveloperApiService.definition)
    .service(Services.Api.AlertsActionsApiService.name, Services.Api.AlertsActionsApiService.definition)
    .service(Services.Api.ConfigApiService.name, Services.Api.ConfigApiService.definition)
    .service(Services.Api.AlertsApiService.name, Services.Api.AlertsApiService.definition)
    .service(Services.Api.NotificationsApiService.name, Services.Api.NotificationsApiService.definition)
    .constant(Services.Api.ThingsApi.Constant.name, Services.Api.ThingsApi.Constant.value)
    .service(Services.Api.ThingsApi.Service.name, Services.Api.ThingsApi.Service.definition)
    .service(Services.Api.EventsApiService.name, Services.Api.EventsApiService.definition)
    .service(Services.Api.HistoryApiService.name, Services.Api.HistoryApiService.definition)
    .service(Services.Api.NotesApiService.name, Services.Api.NotesApiService.definition)
    .service(Services.Api.LabelsApiService.name, Services.Api.LabelsApiService.definition)
    .service(Services.Api.AuthUsersApiService.name, Services.Api.AuthUsersApiService.definition)
    .service(Services.Api.FoldersApiService.name, Services.Api.FoldersApiService.definition)
    .service(Services.Api.ViewsApiService.name, Services.Api.ViewsApiService.definition)
    .service(Services.Api.CategoriesApiService.name, Services.Api.CategoriesApiService.definition)
    .service(Services.Api.NavigationApiService.name, Services.Api.NavigationApiService.definition)
    .service(Services.Api.CustomersApiService.name, Services.Api.CustomersApiService.definition)
    .service(Services.Api.RolesApiService.name, Services.Api.RolesApiService.definition)
    .service(Services.Api.UsersApiService.name, Services.Api.UsersApiService.definition)
    .service(Services.Api.PrivilegesApiService.name, Services.Api.PrivilegesApiService.definition)
    .service(Services.Api.FeedbackApiService.name, Services.Api.FeedbackApiService.definition)
    .filter(Filters.Plural.name, Filters.Plural.definition)
    .run(AppBootstrap)
;



// WEBPACK FOOTER //
// ./app/index.js